// src/pages/VendorOrdersPage.js
import React, { useEffect, useState } from "react";
import API from "../utils/api";

const VendorOrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  const fetchOrders = async () => {
    try {
      const res = await API.get("/orders/vendor-orders");
      setOrders(res.data);
    } catch (err) {
      console.error("Failed to fetch vendor orders", err);
      setMessage("❌ Failed to load orders");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleConfirm = async (id) => {
    try {
      await API.post(`/orders/${id}/confirm`);
      setMessage("✅ Order confirmed!");
      fetchOrders(); // refresh after confirming
    } catch (err) {
      setMessage("❌ Failed to confirm order");
      console.error("Confirm order error:", err.response?.data || err.message);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white">
        <p className="animate-pulse">Loading user purchase requests...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white p-6">
      <h1 className="text-2xl font-bold mb-6">User Purchase Requests</h1>
      {message && <p className="mb-4">{message}</p>}

      {orders.length === 0 ? (
        <p>No purchase requests found.</p>
      ) : (
        <div className="space-y-4">
          {orders.map((order) => (
            <div
              key={order._id}
              className="bg-gray-800 p-4 rounded-xl shadow border border-gray-700"
            >
              {/* ✅ Fix: backend sends buyer, not userId */}
              <p className="font-bold">{order.buyer?.name}</p>
              <p className="text-sm text-gray-400">📧 {order.buyer?.email}</p>
              <p className="text-sm text-gray-400">📞 {order.buyer?.phone}</p>

              <p className="text-sm">💰 Amount: {order.amount} coins</p>

              {/* ✅ Align status with backend (pending / confirmed) */}
              <p
                className={`text-sm ${
                  order.status === "pending"
                    ? "text-yellow-400"
                    : order.status === "confirmed"
                    ? "text-green-400"
                    : "text-red-400"
                }`}
              >
                Status: {order.status}
              </p>

              {order.status === "pending" && (
                <button
                  onClick={() => handleConfirm(order._id)}
                  className="mt-3 bg-green-600 hover:bg-green-700 px-4 py-2 rounded-lg"
                >
                  ✅ Confirm Payment
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VendorOrdersPage;
